"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPagination = void 0;
exports.buildPagination = function (pageSize, pageIndex, displayedRange, itemCount) {
    var totalPages = Math.ceil(itemCount / pageSize);
    var rangeStart = Math.max(0, pageIndex - Math.floor(displayedRange / 2));
    var rangeEnd = rangeStart + displayedRange - 1;
    if (rangeEnd >= totalPages) {
        rangeEnd = totalPages - 1;
        rangeStart = Math.max(0, rangeEnd - displayedRange + 1);
    }
    var nextPage = pageIndex < totalPages - 1 ? pageIndex + 1 : null;
    var previousPage = pageIndex > 0 ? pageIndex - 1 : null;
    return {
        totalPages: totalPages,
        rangeStart: rangeStart,
        rangeEnd: rangeEnd,
        nextPage: nextPage,
        previousPage: previousPage,
    };
};
//# sourceMappingURL=buildPagination.js.map